import React, { useEffect, useState } from "react";
import FileDownloader from './FileDownloader';

const UserTable = ({ BASE_URL, currentFilter, pageSize }) => {
  const [users, setUsers] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [inputPage, setInputPage] = useState('');
  const [totalEmails, setTotalEmails] = useState(0);
  const [totalPhones, setTotalPhones] = useState(0);

  useEffect(() => {
    fetch(`${BASE_URL}/1?${currentFilter}`)
      .then(res => res.json())
      .then(data => {
        setTotalRows(data.cachedTotal.totalRecords)
        setTotalEmails(data.cachedTotal.totalEmails)
        setTotalPhones(data.cachedTotal.totalPhones)
        setPageIndex(1)
      })
      .catch(err => console.error("Error al obtener totalRecords:", err));
  }, [BASE_URL,currentFilter]);

  useEffect(() => {
    fetch(`${BASE_URL}?${currentFilter}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pageNumber: pageIndex, pageSize: pageSize })
    })
      .then(res => res.json())
      .then(data => setUsers(data.result.pageData))
      .catch(err => console.error("Error al obtener datos:", err));
  }, [BASE_URL,currentFilter,pageIndex,pageSize]);

  const totalPages = Math.ceil(totalRows / pageSize);

  const irAPagina = (e) => {
    e.preventDefault();
    const pagina = Number(inputPage);
    if (!isNaN(pagina) && pagina >= 1 && pagina <= totalPages) {
      setPageIndex(pagina);
      setInputPage('');
    }
  };

  return (
  <div>
    <div className="bg-white shadow-md rounded-md p-4 text-gray-800 text-center space-y-2">
      <p className="text-lg font-medium">
        🧑 Ciudadanos: <span className="text-blue-600 font-semibold">{totalRows.toLocaleString('de-DE')}</span> | 
        ✉️ Emails: <span className="text-green-600 font-semibold">{totalEmails.toLocaleString('de-DE')}</span> | 
        📞 Teléfonos: <span className="text-purple-600 font-semibold">{totalPhones.toLocaleString('de-DE')}</span>
      </p>
    </div>

    <div className="p-6">
      <div className="overflow-auto rounded-lg shadow-lg border border-gray-200">
        <table className="min-w-full bg-white text-sm text-gray-800">
          <thead className="bg-gray-100 text-gray-600 uppercase text-xs font-semibold">
            <tr>
              <th className="px-4 py-2 text-left">Nombre</th>
              <th className="px-4 py-2 text-left">Rut</th>
              <th className="px-4 py-2 text-left">Dv</th>
              <th className="px-4 py-2 text-left">Sexo</th>
              <th className="px-4 py-2 text-left">Dirección</th>
              <th className="px-4 py-2 text-left">Circumscripcion</th>
              <th className="px-4 py-2 text-left">Mesa</th>
              <th className="px-4 py-2 text-left">Local</th>
              <th className="px-4 py-2 text-left">Pueblo Indígena</th>
              <th className="px-4 py-2 text-left">Pag</th>
              <th className="px-4 py-2 text-left">Región</th>
              <th className="px-4 py-2 text-left">Provincia</th>
              <th className="px-4 py-2 text-left">Comuna</th>
              <th className="px-4 py-2 text-left">Distrito</th>
              <th className="px-4 py-2 text-left">Teléfono</th>
              <th className="px-4 py-2 text-left">Email</th>
            </tr>
          </thead>
          <tbody>
            {users.map(data => (
              <tr key={data._id} className="border-t border-gray-200 hover:bg-gray-50">
                <td className="px-4 py-2">{data.name?.[0]?.name || ""}</td>
                <td className="px-4 py-2">{data._id}</td>
                <td className="px-4 py-2">{data.dv?.[0]?.dv || ""}</td>
                <td className="px-4 py-2">{data.sex?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.address?.[0]?.address || ""}</td>
                <td className="px-4 py-2">{data.circumscription?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.tableNumberId}</td>
                <td className="px-4 py-2">{data.local?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.ethnicity?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.pageId}</td>
                <td className="px-4 py-2">{data.region?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.province?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.commune?.[0]?.key || ""}</td>
                <td className="px-4 py-2">{data.district?.[0]?.key || ""}</td>
                <td className="px-4 py-2">
                  {data.phones?.length
                    ? data.phones.map(p => p.phones.join("\n")).join(" ")
                    : ""}
                </td>
                <td className="px-4 py-2">
                  {data.emails?.length
                    ? data.emails.map(e => e.emails.join("\n")).join(" ")
                    : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Controles de paginación */}
      <div className="mt-4 flex justify-center items-center gap-4">
        <button
          onClick={() => setPageIndex(p => Math.max(p - 1, 1))}
          disabled={pageIndex === 1}
          className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
        >
          ◀ Anterior
        </button>
        <span className="text-sm font-medium">Página {pageIndex} de {totalPages}</span>
        <button
          onClick={() => setPageIndex(p => p + 1)}
          disabled={(pageIndex * pageSize) >= totalRows}
          className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded disabled:opacity-50"
        >
          Siguiente ▶
        </button>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 mt-4">
        <form onSubmit={irAPagina} className="flex items-right gap-2">
          <label htmlFor="goPage" className="text-sm">Ir a:</label>
          <input
            id="goPage"
            type="number"
            className="border px-2 py-1 rounded w-20 text-sm"
            min={1}
            max={totalPages}
            value={inputPage}
            onChange={(e) => setInputPage(e.target.value)}
          />
          <button
            type="submit"
            className="px-2 py-1 text-sm border rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Ir
          </button>
        </form>
      </div>

      <FileDownloader 
        endpoint={BASE_URL + "?" + currentFilter} pageSize={pageSize} numberOfPages={totalPages} />
    </div>

  </div>
  );
};

export default UserTable;

